var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("custom-tooltip", {
    scopedSlots: _vm._u(
      [
        _vm.staffIsLoaded
          ? {
              key: "contentTooltip",
              fn: function() {
                return [
                  _c("compass-avatar", {
                    attrs: {
                      initials: _vm.initials,
                      "is-blocked": _vm.isStaffBlocked(_vm.idStaff),
                      "is-deleted": _vm.isStaffDeleted(_vm.idStaff),
                      src: _vm.staff ? _vm.staff.avatar : "",
                      "color-type": _vm.randAvatarColor,
                      size: "extra-small"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "semibold" }, [
                    _vm._v(_vm._s(_vm.content))
                  ])
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "triggerTooltip",
          fn: function() {
            return [
              _c("CompassLink", {
                staticClass: "mention",
                class: _vm.color,
                attrs: {
                  disabled: _vm.isStaffDeleted(_vm.idStaff),
                  link: _vm.idStaff ? "/staff/" + _vm.idStaff : "#",
                  target: _vm.idStaff ? "_blank" : "_self",
                  label: _vm.text
                }
              })
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }